import { useEffect, useState } from "react";
import { getAppIconUrl, subscribeAppIcon } from "../lib/favicon";

/** Live app icon URL (CMS favicon when set, otherwise the default 1:1 mark). */
export function useAppIcon() {
  const [url, setUrl] = useState(getAppIconUrl);

  useEffect(() => subscribeAppIcon(setUrl), []);

  return url;
}
